import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';

const SvgSparkle = ({
  alt = 'Sparkle Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <g>
      <path
        fill="currentColor"
        d="M15.352 3.994A.54.54 0 0 0 15 4.5c0 .225.14.427.352.506L18 6l.994 2.648a.54.54 0 0 0 1.012 0L21 6l2.648-.994A.54.54 0 0 0 24 4.5a.54.54 0 0 0-.352-.506L21 3 20.006.352A.54.54 0 0 0 19.5 0a.54.54 0 0 0-.506.352L18 3zm-5.738-.558a.747.747 0 0 0-1.36 0L5.78 8.78.436 11.25a.75.75 0 0 0-.436.684c0 .296.169.558.436.68l5.348 2.47 2.466 5.344a.747.747 0 0 0 1.36 0l2.47-5.348 5.348-2.47a.747.747 0 0 0 0-1.36l-5.344-2.466zM18 18l-2.648.994A.54.54 0 0 0 15 19.5c0 .225.14.427.352.506L18 21l.994 2.648a.54.54 0 0 0 1.012 0L21 21l2.648-.994A.54.54 0 0 0 24 19.5a.54.54 0 0 0-.352-.506L21 18l-.994-2.648A.54.54 0 0 0 19.5 15a.54.54 0 0 0-.506.352z"
      />
    </g>
    <defs>
      <clipPath>
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSparkle;
